jQuery(document).ready(function($) {

    $('.js-spec-title').click(function() {
        $(this).toggleClass('is-active');
        var specList = $(this).next('.js-spec-list');
        specList.slideToggle();
        specList.toggleClass('is-active');
    });

});
